define('TescoMobile_Checkout/js/model/payment-information',['ko'], function (ko) {
  'use strict';

  return {
    response: ko.observable(null),
    paymentIframeUrl: ko.observable(null),
    aggremantIframeUrl: ko.observable(null),
    ccaIframeUrl: ko.observable(null),
    cardDetailsRetry: ko.observable(false),
    lockedSteps: ko.observableArray(['t-and-c-step', 'cca-step', 'payment'])
  };
});

